import ticketDetails from '../localization-messages/ticketDetails/pt-BR.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/pt-BR.json';
import ticketListing from '../localization-messages/ticketListing/pt-BR.json';
import ticketForm from '../localization-messages/ticketForm/pt-BR.json';
import headerFooter from '../localization-messages/headerFooter/pt-BR.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/pt-BR.json';
import termsModal from '../localization-messages/termsModal/pt-BR.json';

export const ptBRTranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
